'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FaqPatientTabContent } from './faq-patient-tab-content.component';
import { FaqProfessionalTabContent } from './faq-professional-tab-content.component';

import { FaqTopic } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/faq.type';
import { HelpPost } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/help-post.type';
import { Tabs, TabsContent, TabsList, TabsProvider, TabsTrigger } from '@/components/ui/tabs';
import { ContentContainer } from '@/components/ui/content-container.component';

interface FaqTabsProps {
  faqContent: FaqTopic[];
  helpPosts: HelpPost[];
}

export const FaqTabs = ({ faqContent, helpPosts }: FaqTabsProps) => {
  return (
    <TabsProvider>
      <Tabs defaultValue="patient" activationMode="manual" className="w-full flex flex-col items-start">
        <ContentContainer className="lg:max-w-3xl">
          <TabsList className="flex flex-row items-center gap-4 mb-10 mt-6 w-max">
            <TabsTrigger value="patient" data-testid={DataTestIdEnum.FAQ_PATIENT_TAB_TRIGGER}>
              Paciente
            </TabsTrigger>
            <TabsTrigger value="professional" data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_TAB_TRIGGER}>
              Profissional de saúde
            </TabsTrigger>
          </TabsList>
        </ContentContainer>

        <TabsContent value="patient" className="flex flex-col w-full">
          <FaqPatientTabContent faqContent={faqContent} helpPosts={helpPosts} />
        </TabsContent>

        <TabsContent value="professional" className="flex flex-col w-full">
          <FaqProfessionalTabContent />
        </TabsContent>
      </Tabs>
    </TabsProvider>
  );
};
